import { AxiosInstance } from 'axios';

export function createForecastApi(client: AxiosInstance) {
  return {
    async getForecasts() { const r = await client.get('/forecasts'); return r.data; },
    async getForecast(id: number) { const r = await client.get(`/forecasts/${id}`); return r.data; },
    async createForecast(data: any) { const r = await client.post('/forecasts', data); return r.data; },
    async updateForecast(id: number, data: any) { const r = await client.patch(`/forecasts/${id}`, data); return r.data; },
    async deleteForecast(id: number) { const r = await client.delete(`/forecasts/${id}`); return r.data; },
    async createForecastSnapshot(id: number, data: any) { const r = await client.post(`/forecasts/${id}/snapshots`, data); return r.data; },
  };
}

export type ForecastApi = ReturnType<typeof createForecastApi>;
